export function formatDuration(seconds: number) {
  const s = Math.round(seconds);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) {
    return m > 0
      ? `${h} hour${h > 1 ? "s" : ""} ${m} min`
      : `${h} hour${h > 1 ? "s" : ""}`;
  } else if (m > 0) {
    return `${m} min`;
  } else {
    return `${sec} sec`;
  }
}

export function formatSize(size: number) {
  return (size / (1024 * 1024)).toFixed(2) + " MB";
}
